import { meta } from '../../../constants';
import { ChatsProvider } from '../../../constants/types';
import { ChatLayout } from './ChatLayout';

const { provider } = meta;

const AVATAR_WITH_TIME = {
  isAvatar: true,
  timeOnHeader: true,
  messageShadow: false
};

const CHAT_WINDOW_CONFIG = {
  [ChatsProvider.facebook]: {
    avatarSize: 30,
    ...AVATAR_WITH_TIME
  },
  [ChatsProvider.whatsapp]: {
    dotType: 'whatsapp' as 'whatsapp' | 'default'
  },
  [ChatsProvider.telegram]: {
    dotType: 'whatsapp' as 'whatsapp' | 'default'
  },
  [ChatsProvider.instagram]: {
    avatarSize: 30,
    ...AVATAR_WITH_TIME
  },
  [ChatsProvider.viber]: {
    avatarSize: 28,
    ...AVATAR_WITH_TIME
  },
  [ChatsProvider.all]: {
    avatarSize: 28,
    ...AVATAR_WITH_TIME
  },
  [ChatsProvider.line]: {},
  [ChatsProvider.discord]: {}
}[provider];

export const ChatWindow = () => {
  return <ChatLayout {...CHAT_WINDOW_CONFIG} timeOnHeader />;
};
